import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { KeyboardDismissWrapper } from '@/components/common/KeyboardDismissWrapper';
import { SVG_COMPONENTS, SVG_DIMENSIONS } from '@/assets/admin';
import { ADMIN_COLORS } from '@/constants/admin';

type ButtonType = 'add' | 'download';

interface TitleWithActionsProps {
  title: string;
  showAddButton?: boolean;
  showSelector?: boolean;
  showControlBar?: boolean;
  onAddPress?: () => void;
  buttonType?: ButtonType;
}

export const TitleWithActions: React.FC<TitleWithActionsProps> = ({
  title,
  showAddButton = true,
  showSelector = false,
  showControlBar = false,
  onAddPress,
  buttonType = 'add',
}) => {
  return (
    <KeyboardDismissWrapper style={styles.container}>
      <View style={styles.top}>
        <Text style={styles.titleText}>{title}</Text>
        {showAddButton && (
          <View style={styles.btns}>
            <TouchableOpacity
              style={styles.actionButton}
              onPress={onAddPress}
              activeOpacity={0.8}
              accessibilityLabel={buttonType === 'add' ? "Add new item" : "Download"}
              accessibilityHint={buttonType === 'add' ? "Tap to create a new item" : "Tap to download"}
              accessibilityRole="button"
            >
              {buttonType === 'add' ? (
                <SVG_COMPONENTS.ADD_BUTTON {...SVG_DIMENSIONS.ADD_BUTTON} />
              ) : (
                <SVG_COMPONENTS.DOWNLOAD {...SVG_DIMENSIONS.DOWNLOAD} />
              )}
            </TouchableOpacity>
          </View>
        )}
      </View>
    </KeyboardDismissWrapper>
  );
};

const styles = StyleSheet.create({
  container: {
    width: 325,
    height: 34,
    gap: 16,
  },
  top: {
    width: 325,
    height: 34,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 0, // No container padding - we'll handle spacing manually
  },
  titleText: {
    flex: 1, // Take available space
    height: 33,
    fontFamily: 'Euclid Circular B',
    fontWeight: '600',
    fontSize: 22,
    lineHeight: 33, // 150% of 22px
    letterSpacing: 0,
    color: ADMIN_COLORS.BULLETINS.TITLE_TEXT,
    marginLeft: 0, // Title starts at container edge
    marginRight: 20, // Gap between title and button
  },
  btns: {
    width: 34,
    height: 34,
    marginRight: -15, // Gap between title and button
    justifyContent: 'center',
    alignItems: 'center', // Center the button within its container
  },
  actionButton: {
    width: 34,
    height: 34,
    paddingHorizontal: 0, // Remove horizontal padding to eliminate extra spacing
    paddingVertical: 0,
    borderRadius: 8,
    backgroundColor: ADMIN_COLORS.BUTTON.ADD_BUTTON_BACKGROUND,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
